import React, { useContext } from 'react';
import useInitFirebase from 'modules/Firebase/hooks/useInitFirebase';
import useFirebase from 'modules/Firebase/hooks/useFirebase';

const FirebaseContext = React.createContext(null);

function FirebaseProvider({ children }) {
    useInitFirebase();
    const providers = useFirebase();

    return <FirebaseContext.Provider value={providers}>{children}</FirebaseContext.Provider>;
}

export default FirebaseProvider;

export function useFirebaseProviders() {
    return useContext(FirebaseContext);
}
